<template>
  <div>
    <a-modal v-model="visible" :title="getTitle" :width="960" centered :mask-closable="false" :ok-button-props="{ props: { loading: loading } }" @cancel="onCancel" @ok="onSubmit">
      <a-spin :spinning="spinning">
        <a-form-model ref="form" :model="form" :rules="rules" :form="form">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item label="计划名称" prop="name">
                <a-input v-model="form.name" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="描述" prop="description">
                <vditor-editor v-model="form.description" :height="200" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="测试类型" prop="type">
                <a-select v-model="form.type" allow-clear placeholder="测试类型">
                  <a-select-option v-for="(item, index) in testPlanTypes" :key="index" :value="item.value">
                    <a-tag :color="item.color"> {{ item.label }}</a-tag>
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="开始时间" prop="start_time">
                <a-date-picker v-model="form.start_time" :disabled-date="disabledStartDate" value-format="YYYY-MM-DD" style="width: 100%" placeholder="请选择开始时间" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="结束时间" prop="end_time">
                <a-date-picker v-model="form.end_time" :disabled-date="disabledEndDate" value-format="YYYY-MM-DD" style="width: 100%" placeholder="请选择结束时间" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="负责人" prop="handlers">
                <user-select v-model="form.handlers" mode="multiple" show-search placeholder="负责人" :project-id="projectId" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="关联需求">
                <!-- <a-tree-select v-model="selectRequirement" label-in-value show-search multiple allow-clear tree-default-expand-all placeholder="请选择需求" :filter-tree-node="filterRequirement" :replace-fields="{ title: 'newTitle', value: 'id' }" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="requirementData" :search-value.sync="searchValue" @search="getStoryTree" @change="onChange" /> -->
                <a-select v-model="selectRequirement" mode="multiple" show-search allow-clear label-in-value :filter-option="false" :not-found-content="storySearching ? undefined : null" placeholder="请选择需求" @search="searchStory" @change="onChange">
                  <a-spin v-if="storySearching" slot="notFoundContent" size="small" />
                  <a-select-option v-for="item in searchStoryData" :key="item.value" :value="item.value">
                    <span style="color: #999; font-size: 12px">PR-{{ item.id }}</span> {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="关联任务">
                <a-select v-model="taskValue" allow-clear show-search label-in-value mode="multiple" style="width: 100%" placeholder="请选择任务" :filter-option="utils.filterOption" :not-found-content="taskSearching ? undefined : null" @search="searchTask" @change="handleTaskChange">
                  <a-spin v-if="taskSearching" slot="notFoundContent" size="small" />
                  <a-select-option v-for="item in searchTaskData" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import { taskSearch } from '@/api/project/task';
import { storySearch } from '@/api/project/story';
import { testPlanTypes } from '@/utils/dictionary';
import { testPlanAdd, testPlanDetail, testPlanUpdate } from '@/api/project/testPlan';

import moment from 'moment/moment';
import VditorEditor from '@/components/VditorEditor';
import UserSelect from '@/components/User/UserSelect';

export default {
  components: { VditorEditor, UserSelect },
  props: {
    planId: {
      type: [Number, String],
      default: null
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      testPlanTypes,
      spinning: false,
      loading: false,
      visible: false,
      projects: [],
      projectId: parseInt(this.$route.params.project_id) || null,
      searchStoryData: [],
      storySearching: false,
      versionSearching: false,
      taskValue: [],
      taskSearching: false,
      searchTaskData: [],
      form: {
        name: null,
        description: '',
        type: null,
        handlers: [],
        start_time: null,
        end_time: null,
        requirements: [],
        tasks: []
      },
      rules: {
        name: [{ required: true, message: '计划名称不能为空', trigger: 'blur' }],
        type: [{ required: true, message: '测试类型不能为空', trigger: 'blur' }],
        handlers: [{ required: true, message: '测试负责人不能为空', trigger: 'blur' }]
      },
      selectRequirement: [],
      requirementData: [],
      searchValue: ''
    };
  },
  computed: {
    getTitle() {
      if (this.planId !== null) {
        return '编辑测试计划';
      } else {
        return '添加测试计划';
      }
    }
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.visible === true) {
        if (this.planId !== null) {
          this.getTestPlanDetail(this.planId);
        }
      }
    }
  },
  methods: {
    // 任务搜索
    searchTask(value) {
      taskSearch({ project_id: this.projectId, value: value }).then(res => {
        this.searchTaskData = res.data.items;
      });
    },

    handleTaskChange(value) {
      if (value) {
        this.form.tasks = value.map(task => task.key);
      } else {
        this.form.tasks = null;
      }
    },

    filterRequirement(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },
    genNewNode(node) {
      if (node.children) {
        node.children = node.children.map(child => this.genNewNode(child));
      }
      return {
        id: node.id,
        key: node.key,
        title: node.title,
        children: node.children,
        newTitle: node.key + ' ' + node.title
      };
    },

    onChange() {
      this.form.requirements = this.selectRequirement.map(requirement => requirement.value);
    },
    closed() {
      this.visible = false;
      this.loading = false;
      this.form = {};
      this.$emit('close');
    },

    onCancel() {
      this.utils.trackClick({ name: '取消编辑测试计划' });
      this.closed();
    },

    // 需求搜索
    searchStory(value) {
      this.storySearching = true;
      storySearch({ project_id: this.projectId, value: value, page_size: 20, page_number: 1 })
        .then(res => {
          this.searchStoryData = res.data.items;
          this.storySearching = false;
        })
        .finally(() => {
          this.storySearching = false;
        });
    },

    // 获取缺陷详情
    getTestPlanDetail(planId) {
      this.spinning = true;
      testPlanDetail({ test_plan_id: planId, project_id: this.projectId }).then(res => {
        const data = res.data;
        this.form = {
          ...this.form,
          name: data.name,
          description: data.description,
          status: data.status,
          start_time: data.start_time,
          end_time: data.end_time,
          type: data.type,
          handlers: data.handlers ? data.handlers.map(handler => handler.id) : []
        };
        this.selectRequirement = (data.requirements || []).map(req => ({ value: req, key: req, label: `PR-${req}` }));
        if (data.tasks) {
          this.searchTaskData = data.tasks.map(task => {
            return { key: task.id, label: task.name, value: task.id };
          });
          this.taskValue = data.tasks.map(task => {
            return { key: task.id, label: task.name, value: task.id };
          });
          this.form.tasks = this.taskValue.map(task => task.key);
        } else {
          this.taskValue = [];
        }
        this.spinning = false;
      });
    },

    // 点击提交
    onSubmit() {
      this.utils.trackClick({ name: '保存测试计划' });
      const form = {
        ...this.form,
        requirements: this.selectRequirement.map(requirement => requirement.key)
      };
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.planId === null) {
            // 添加测试计划
            testPlanAdd({ project_id: this.projectId, ...form })
              .then(() => {
                this.closed();
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            // 编辑测试计划
            testPlanUpdate({ test_plan_id: this.planId, project_id: this.projectId, ...form })
              .then(() => {
                this.closed();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    },
    disabledStartDate(startValue) {
      const endValue = moment(this.form.end_time || null);
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = moment(this.form.start_time || null);
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 4px;
}

/deep/ .ant-form-item-label {
  line-height: 32px;
}

.submit {
  width: 100px;
  margin: 0 auto;
}

/deep/ .ant-modal-body {
  padding: 8px 48px 16px 48px;
}
</style>
